import { buildModelManager } from "../builder.js";
const DefaultWorkItemSelection = {
  __typename: true,
  id: true,
  actualEnd: true,
  actualStart: true,
  address: true,
  assignedToMembershipId: true,
  bookingSource: true,
  cadenceDays: true,
  cadenceUnit: true,
  clientId: true,
  createdAt: true,
  currentStageId: true,
  deletedAt: true,
  description: true,
  doneAt: true,
  durationEstimate: true,
  entryStatus: true,
  invoiceId: true,
  isAllDay: true,
  lockedAt: true,
  meetingUrl: true,
  notes: true,
  parentWorkItemId: true,
  prebookCount: true,
  priceCurrency: true,
  priceEstimate: true,
  priority: true,
  profileId: true,
  propertyId: true,
  quoteAcceptedAt: true,
  quoteDeclineReason: true,
  quoteDeclinedAt: true,
  quoteDepositPaidAt: true,
  quoteDepositRequiredAt: true,
  quoteExpiresAt: true,
  quoteSentAt: true,
  rawCapture: true,
  reminderLeadDays: true,
  scheduledConfirmedAt: true,
  scheduledEnd: true,
  scheduledStart: true,
  scheduledStatus: true,
  seriesAnchor: true,
  seriesEndsAt: true,
  seriesId: true,
  shareToken: true,
  source: true,
  subcontractQuoteDueAt: true,
  subcontractedFromWorkItemId: true,
  subtype: true,
  title: true,
  updatedAt: true
};
const modelApiIdentifier = "workItem";
const pluralModelApiIdentifier = "workItems";
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWorkItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWorkItemSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByShareToken",
    findByField: "shareToken",
    findByVariableName: "shareToken",
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByShareToken",
    findByField: "shareToken",
    findByVariableName: "shareToken",
    modelApiIdentifier,
    defaultSelection: DefaultWorkItemSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createWorkItem",
    operationReturnType: "CreateWorkItem",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { workItem: { required: false, type: "CreateWorkItemInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkCreateWorkItems",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateWorkItemsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "updateWorkItem",
    operationReturnType: "UpdateWorkItem",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "UpdateWorkItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateWorkItems",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateWorkItemsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "deleteWorkItem",
    operationReturnType: "DeleteWorkItem",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteWorkItems",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "addErrandWorkItem",
    operationReturnType: "AddErrandWorkItem",
    functionName: "addErrand",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      workItem: { required: false, type: "AddErrandWorkItemInput" },
      parentId: { required: false, type: "String" },
      title: { required: false, type: "String" },
      notes: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["parentId", "title", "notes"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkAddErrandWorkItems",
    functionName: "bulkAddErrand",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "addErrand",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkAddErrandWorkItemsInput!]" }
    },
    paramOnlyVariables: ["parentId", "title", "notes"],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "addFollowUpWorkItem",
    operationReturnType: "AddFollowUpWorkItem",
    functionName: "addFollowUp",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { workItem: { required: false, type: "AddFollowUpWorkItemInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkAddFollowUpWorkItems",
    functionName: "bulkAddFollowUp",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "addFollowUp",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkAddFollowUpWorkItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "addNoteWorkItem",
    operationReturnType: "AddNoteWorkItem",
    functionName: "addNote",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "AddNoteWorkItemInput" },
      content: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["content"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkAddNoteWorkItems",
    functionName: "bulkAddNote",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "addNote",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkAddNoteWorkItemsInput!]" }
    },
    paramOnlyVariables: ["content"],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "advanceStageWorkItem",
    operationReturnType: "AdvanceStageWorkItem",
    functionName: "advanceStage",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "AdvanceStageWorkItemInput" },
      targetStageId: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["targetStageId"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkAdvanceStageWorkItems",
    functionName: "bulkAdvanceStage",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "advanceStage",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkAdvanceStageWorkItemsInput!]" }
    },
    paramOnlyVariables: ["targetStageId"],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "confirmSlotWorkItem",
    operationReturnType: "ConfirmSlotWorkItem",
    functionName: "confirmSlot",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "ConfirmSlotWorkItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkConfirmSlotWorkItems",
    functionName: "bulkConfirmSlot",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "confirmSlot",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkConfirmSlotWorkItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "markErrandDoneWorkItem",
    operationReturnType: "MarkErrandDoneWorkItem",
    functionName: "markErrandDone",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "MarkErrandDoneWorkItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkMarkErrandDoneWorkItems",
    functionName: "bulkMarkErrandDone",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "markErrandDone",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkMarkErrandDoneWorkItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "markErrandUndoneWorkItem",
    operationReturnType: "MarkErrandUndoneWorkItem",
    functionName: "markErrandUndone",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "MarkErrandUndoneWorkItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkMarkErrandUndoneWorkItems",
    functionName: "bulkMarkErrandUndone",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "markErrandUndone",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkMarkErrandUndoneWorkItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "pencilNextSlotWorkItem",
    operationReturnType: "PencilNextSlotWorkItem",
    functionName: "pencilNextSlot",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "PencilNextSlotWorkItemInput" },
      operation: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["operation"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkPencilNextSlotWorkItems",
    functionName: "bulkPencilNextSlot",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "pencilNextSlot",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkPencilNextSlotWorkItemsInput!]" }
    },
    paramOnlyVariables: ["operation"],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "regressStageWorkItem",
    operationReturnType: "RegressStageWorkItem",
    functionName: "regressStage",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "RegressStageWorkItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkRegressStageWorkItems",
    functionName: "bulkRegressStage",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "regressStage",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRegressStageWorkItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "releaseSlotWorkItem",
    operationReturnType: "ReleaseSlotWorkItem",
    functionName: "releaseSlot",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "ReleaseSlotWorkItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkReleaseSlotWorkItems",
    functionName: "bulkReleaseSlot",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "releaseSlot",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkReleaseSlotWorkItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "requestScopesWorkItem",
    operationReturnType: "RequestScopesWorkItem",
    functionName: "requestScopes",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "RequestScopesWorkItemInput" },
      scopeKeys: { required: false, type: "[String!]" },
      message: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["scopeKeys", "message"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkRequestScopesWorkItems",
    functionName: "bulkRequestScopes",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "requestScopes",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRequestScopesWorkItemsInput!]" }
    },
    paramOnlyVariables: ["scopeKeys", "message"],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "restoreWorkItem",
    operationReturnType: "RestoreWorkItem",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "RestoreWorkItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreWorkItems",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestoreWorkItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "subcontractWorkItem",
    operationReturnType: "SubcontractWorkItem",
    functionName: "subcontract",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "SubcontractWorkItemInput" },
      targetProfileId: { required: false, type: "String" },
      scope: { required: false, type: "String" },
      quoteRequiredBy: { required: false, type: "String" },
      priceCeiling: { required: false, type: "Float" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["targetProfileId", "scope", "quoteRequiredBy", "priceCeiling"],
    hasReturnType: true,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkSubcontractWorkItems",
    functionName: "bulkSubcontract",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "subcontract",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkSubcontractWorkItemsInput!]" }
    },
    paramOnlyVariables: ["targetProfileId", "scope", "quoteRequiredBy", "priceCeiling"],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "updateRemindersWorkItem",
    operationReturnType: "UpdateRemindersWorkItem",
    functionName: "updateReminders",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "UpdateRemindersWorkItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateRemindersWorkItems",
    functionName: "bulkUpdateReminders",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "updateReminders",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateRemindersWorkItemsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "withdrawSubcontractWorkItem",
    operationReturnType: "WithdrawSubcontractWorkItem",
    functionName: "withdrawSubcontract",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      workItem: { required: false, type: "WithdrawSubcontractWorkItemInput" },
      inviteId: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["inviteId"],
    hasReturnType: true,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkWithdrawSubcontractWorkItems",
    functionName: "bulkWithdrawSubcontract",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "withdrawSubcontract",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkWithdrawSubcontractWorkItemsInput!]"
      }
    },
    paramOnlyVariables: ["inviteId"],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "upsertWorkItem",
    operationReturnType: "UpsertWorkItem",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      workItem: { required: false, type: "UpsertWorkItemInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateWorkItemResult": { hasReturnType: false },
      "... on UpdateWorkItemResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertWorkItems",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertWorkItemsInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultWorkItemSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "workItemGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const WorkItemManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultWorkItemSelection,
  operations
);
export {
  DefaultWorkItemSelection,
  WorkItemManager
};
//# sourceMappingURL=WorkItem.js.map
